import { DatabaseOutlined } from '@ant-design/icons';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../v2/MUI_custom_component/Button/CustomButton';
import Lottie from 'lottie-react';
import successLottie from '../../utils/Lottie/NewSuccess.json';
import { trackAnalyticsEvent } from '../../utils/clevertap/clevertapUtils';


const CompletedOrder = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Track order completion page load
    useEffect(() => {
        trackAnalyticsEvent('INVENTORY_ORDER_COMPLETED_PAGE_LOADED', {
            screen_name: 'order_completed',
            action: 'page_load'
        });
    }, []);
    
    const onGoBack = () => {
        // Track return to inventory action
        trackAnalyticsEvent('ORDER_COMPLETED_RETURN_CLICKED', {
            screen_name: 'order_completed',
            action: 'return_to_inventory',
            navigation_target: 'inventory_main'
        });

        dispatch({ type: 'RESET_FMCG_REDUCER' });
        dispatch({ type: 'RESET_BCM_ORDER' });
        navigate('/inventory', { replace: true });
    };
    return (
        <Box
            sx={{
                textAlign: 'center',
                padding: 4,
                backgroundImage: `url(https://d2djimvzddgguw.cloudfront.net/humbee-inventory/pattern_bg.svg)`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left top',
                backgroundSize: 'auto',
            }}
        >
            <Box sx={{ mt: 4, display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center', height: '80vh', }}>
                <Lottie
                    animationData={successLottie}
                    loop={true}
                    style={{ width: 150, height: 150, marginBottom: 20 }}
                />
                <Typography variant='h2'>Successful!</Typography>
                <Typography variant='body1' sx={{ textAlign: 'center', marginBottom: 5 }}>
                    Inventory allocation completed successfully.
                </Typography>
                <CustomButton 
                    variant='filled'
                    color='primary'
                    label={'Return To Inventory'} 
                    onClick={onGoBack}
                    sx={{ width : { xs: '100%', sm: 'auto' }, mb: 2}}
                />
            </Box>
            
        </Box>
    );
}

export default CompletedOrder